import {ChangeEvent, ReactElement, useState} from 'react'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import {uniqueId} from 'lodash'
import DateFnsUtils from '@date-io/date-fns'
import * as dateFnsLocales from 'date-fns/locale'
import {Search} from '@material-ui/icons'
import {FormControl, Grid, Input, InputAdornment, InputLabel} from '@material-ui/core'
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers'
import {FiltersApi} from '../../../../../../../shared/hooks/useFilters'
import {fnsLocales} from '../../../../../../../common/utils/uioptions'
import messages from '../../../../../../../assets/messages'
import {FilterValues} from '../../types'
import {useStyles} from './styles'


type FilterFieldsProps = {
  filtersApi: FiltersApi<FilterValues>
} & WithNamespaces

export function FilterFieldsBase(props: FilterFieldsProps): ReactElement {
  const {filtersApi, lng, t} = props

  const {search, completedAfter, completedBefore} = filtersApi.value

  const [inputId] = useState(uniqueId())
  const classNames = useStyles()

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>): void => {
    filtersApi.change({search: e.target.value})
  }

  const handleCompletedAfterChange = (nextValue: Date | null) => {
    filtersApi.change({completedAfter: nextValue})
  }

  const handleCompletedBeforeChange = (nextValue: Date | null) => {
    filtersApi.change({completedBefore: nextValue})
  }

  return (
    <Grid className={classNames.container}>
      <FormControl className={classNames.input}>
        <InputLabel htmlFor={inputId}>
          <Trans {...messages.search} />
        </InputLabel>
        <Input
          id={inputId}
          value={search}
          onChange={handleSearchChange}
          endAdornment={<InputAdornment className={classNames.adornment} position="end"><Search/></InputAdornment>}
        />
      </FormControl>
      <MuiPickersUtilsProvider
        utils={DateFnsUtils}
        locale={dateFnsLocales[lng ?? fnsLocales['default']] ?? dateFnsLocales[fnsLocales['default']]}
      >
        <KeyboardDatePicker
          label={t(messages.dateFrom.i18nKey, messages.dateFrom.defaults)}
          format="dd/MM/yyyy"
          value={completedAfter}
          maxDate={completedBefore ?? undefined}
          onChange={handleCompletedAfterChange}
          okLabel={t(messages.submit.i18nKey, messages.submit.defaults)}
          cancelLabel={t(messages.cancel.i18nKey, messages.cancel.defaults)}
        />
        <KeyboardDatePicker
          label={t(messages.dateTo.i18nKey, messages.dateTo.defaults)}
          format="dd/MM/yyyy"
          value={completedBefore}
          minDate={completedAfter ?? undefined}
          onChange={handleCompletedBeforeChange}
          okLabel={t(messages.submit.i18nKey, messages.submit.defaults)}
          cancelLabel={t(messages.cancel.i18nKey, messages.cancel.defaults)}
        />
      </MuiPickersUtilsProvider>
    </Grid>
  )
}

export const FilterFields = withNamespaces()(FilterFieldsBase)
